export default __webpack_public_path__ + "static/media/TroxelteacherSection.ee08a5c7.png";